import { Container, Row, Col } from 'reactstrap';

import {useTranslation} from "react-i18next";

// eslint-disable-next-line
import Accordion from 'react-bootstrap/Accordion';

function HelpPage() {
  const {t} = useTranslation('common');

  return (
    <div id='helpPage'>
      <Container id='pageContainer'>
        <Row>
          <Col>
            <div className='sectionHeader'>
              <h1>
                {t('navbar.helpItem')}
              </h1>
            </div>
            <p>
              {t('helpPage.headerText')} <span style={{color:"#6b64ff",fontWeight:"700"}}>+49 176 2397 3014</span>.
            </p> 
            {/* <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0">
                <Accordion.Header>Accordion Item #1</Accordion.Header>
                <Accordion.Body>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                  eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                  minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                  aliquip ex ea commodo consequat. Duis aute irure dolor in
                  reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                  pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                  culpa qui officia deserunt mollit anim id est laborum.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>Accordion Item #2</Accordion.Header>
                <Accordion.Body>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                  eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                  minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                  aliquip ex ea commodo consequat. Duis aute irure dolor in
                  reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                  pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                  culpa qui officia deserunt mollit anim id est laborum.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion> */}
          </Col>
        </Row>
      </Container> 
    </div>     
  )
}

export default HelpPage;